import React from 'react';
import { useI18n } from '../i18n/LanguageContext';

export function LanguageSwitcher({ tone = 'dark' }) {
  const { lang, setLang, languages } = useI18n();
  const baseColor = tone === 'light' ? 'text-sand' : 'text-forest';
  const dim = tone === 'light' ? 'text-sand/45' : 'text-forest/45';

  return (
    <div className="flex items-center gap-2 select-none" data-testid="language-switcher">
      {languages.map((l, i) => (
        <React.Fragment key={l.code}>
          {i > 0 && <span className={`${dim} text-[10px]`}>·</span>}
          <button
            type="button"
            onClick={() => setLang(l.code)}
            aria-label={`Switch language to ${l.name}`}
            data-testid={`lang-${l.code}`}
            className={`text-[11px] font-sans uppercase tracking-[0.22em] transition-colors duration-300 ${
              lang === l.code ? `${baseColor} font-medium` : `${dim} hover:${baseColor.replace('text-', 'text-')}`
            }`}
          >
            {l.label}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
}
